const GATEWAY_TOKEN_STORAGE_KEY = "stonepro.whatsappGatewayToken";
const GATEWAY_CLIENT_ID_STORAGE_KEY = "stonepro.whatsappGatewayClientId";

export function getStoredGatewayToken() {
  return localStorage.getItem(GATEWAY_TOKEN_STORAGE_KEY) || "";
}

export function storeGatewayToken(token) {
  localStorage.setItem(GATEWAY_TOKEN_STORAGE_KEY, String(token || "").trim());
}

export function syncGatewayTokenFromConfig(config) {
  const token = String(config?.gateway_token || "").trim();
  if (token) storeGatewayToken(token);
  return token || getStoredGatewayToken();
}

export function networkPrefixFromIp(ipAddress) {
  const parts = String(ipAddress || "").trim().split(".");
  if (parts.length < 3) return "";
  return parts.slice(0, 3).join(".");
}

export function browserNetworkPrefix() {
  const host = String(window.location.hostname || "").trim();
  if (!/^(10|172|192)\./.test(host)) return "";
  return networkPrefixFromIp(host);
}

export function hasNetworkDivergence(config) {
  const expectedPrefix = String(config?.loop_network_prefix || "").trim();
  const currentPrefix = browserNetworkPrefix();
  return Boolean(expectedPrefix && currentPrefix && expectedPrefix !== currentPrefix);
}

function readLoggedUser() {
  try {
    return JSON.parse(localStorage.getItem("user") || "{}") || {};
  } catch {
    return {};
  }
}

export function currentGatewayClientId() {
  const user = readLoggedUser();
  const userId = String(user?._id || user?.id || user?.user_id || user?.userId || "").trim();
  if (userId) return `stonepro-web-${userId}`;
  let clientId = localStorage.getItem(GATEWAY_CLIENT_ID_STORAGE_KEY);
  if (!clientId) {
    clientId = `stonepro-web-${Date.now()}`;
    localStorage.setItem(GATEWAY_CLIENT_ID_STORAGE_KEY, clientId);
  }
  return clientId;
}

export function gatewayUrl({ gateway_host, gateway_port, session_id }, token, clientId = currentGatewayClientId()) {
  const host = String(gateway_host || "").trim();
  const port = Number(gateway_port || 8790);
  const sectionId = String(session_id || "").trim();
  return `ws://${host}:${port}/stonepro/ws?token=${encodeURIComponent(token)}&clientId=${encodeURIComponent(clientId)}&sectionId=${encodeURIComponent(sectionId)}`;
}

export function listGatewaySessions(config, token = getStoredGatewayToken()) {
  return new Promise((resolve, reject) => {
    if (!String(config.gateway_host || "").trim()) {
      reject(new Error("Informe o IP do gateway local."));
      return;
    }
    if (!String(token || "").trim()) {
      reject(new Error("Informe o token local gerado no Loop."));
      return;
    }
    const socket = new WebSocket(gatewayUrl(config, token));
    const requestId = `sessions-${Date.now()}`;
    const timeout = window.setTimeout(() => {
      socket.close();
      reject(new Error("Tempo esgotado ao conectar no gateway local."));
    }, 7000);
    const finish = callback => {
      window.clearTimeout(timeout);
      socket.close();
      callback();
    };
    socket.addEventListener("open", () => {
      socket.send(JSON.stringify({
        id: requestId,
        name: "whatsapp:sessions:list",
        payload: {}
      }));
    });
    socket.addEventListener("message", event => {
      let response;
      try {
        response = JSON.parse(event.data);
      } catch {
        return;
      }
      if (response.name === "integration:auth:failed") {
        finish(() => reject(new Error(response.message || "Token local invalido.")));
        return;
      }
      if (response.id !== requestId) return;
      if (!response.ok) {
        finish(() => reject(new Error(response.message || "Falha ao listar sessoes.")));
        return;
      }
      finish(() => resolve(Array.isArray(response.payload) ? response.payload : []));
    });
    socket.addEventListener("error", () => {
      finish(() => reject(new Error("Nao foi possivel acessar o gateway local.")));
    });
  });
}
